import { useCallback, useState } from 'react';

import type { GenerationTool } from 'src/data/generationTool';
import type { ScoringMethod } from 'src/data/scoring';
// @ts-expect-error - useInsightsAudienceChartProps has no TypeScript declarations
import { useInsightsAudienceChartProps } from 'src/services/insights/useInsightsAudienceChartProps';
// @ts-expect-error - useTextAudienceDebounced has no TypeScript declarations
import { useTextAudienceDebounced } from 'src/services/useTextAudienceDebounced';
// @ts-expect-error - project store has no TypeScript declarations
import { useCurrentProjectId } from 'src/store/project/useCurrentProjectId';

import { LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT } from './longFormConst';

interface Params {
  generationTool?: GenerationTool | null;
  text: string;
  scoringMethod?: ScoringMethod | null;
  language?: string | null;
  eventPage: string;
}

interface Options {
  disabled?: boolean;
}

export const useLongFormTargetAudienceProps = (
  { generationTool, text, scoringMethod, language, eventPage }: Params,
  { disabled }: Options = {}
) => {
  const projectId = useCurrentProjectId();

  const [refreshKey, setRefreshKey] = useState(0);
  const increaseRefreshKey = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  const audienceData = useTextAudienceDebounced(
    { projectId, generationTool, text, scoringMethod },
    {
      debounceTimeout: LONG_FORM_INSIGHTS_DEBOUNCE_TIMEOUT,
      disabled,
      refreshKey,
    }
  );

  return useInsightsAudienceChartProps({
    audienceData,
    onAfterPersonaUpdate: increaseRefreshKey,
    eventPage,
    language,
  });
};
